export default __webpack_public_path__ + "static/media/certificate-logo.b00c3d61.svg";